import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { AppProvider } from 'foundations-components/components/AppProvider';
import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const AlertContainer = styled.div.withConfig({
  displayName: "useErrorAlert__AlertContainer",
  componentId: "sc-1abygkq-0"
})(({
  theme,
  scrollTop
}) => ({
  top: `${scrollTop}px`,
  height: '100%',
  width: '100%',
  maxWidth: '900px',
  left: '50%',
  transform: 'translate(-50%, 0)',
  position: 'absolute',
  zIndex: 9999999,
  padding: `${theme.space[1300]} ${theme.space[0]}`
}));
const useErrorAlert = () => {
  const rootRef = useRef(document.createElement('div'));
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const scrollTop = useRef(0);
  useEffect(() => {
    if (showErrorAlert) {
      scrollTop.current = document.documentElement.scrollTop;
      const currentRootRef = rootRef.current;
      document.body.appendChild(currentRootRef);
      ReactDOM.render( /*#__PURE__*/_jsx(AppProvider, {
        children: /*#__PURE__*/_jsx(AlertContainer, {
          scrollTop: scrollTop.current,
          children: /*#__PURE__*/_jsx(Alert, {
            type: "danger",
            titleText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.errorModal.title"
            }),
            closeable: true,
            onClose: () => setShowErrorAlert(false),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.errorModal.subtext"
            })
          })
        })
      }), currentRootRef);
      return () => {
        ReactDOM.unmountComponentAtNode(currentRootRef);
        document.body.removeChild(currentRootRef);
      };
    }
    return () => {}; //returning an empty obj to satisfy eslint
  }, [showErrorAlert]);
  return {
    setShowErrorAlert
  };
};
export default useErrorAlert;